export default {
  allRightsReserved: "Core Admin. All rights reserved.",
};
